import FeatureSplashWrapper from './FeatureSplashWrapper'
import './BcardSplashScreen.scss'
const BcardSplashScreen = () => {
  return (
    <FeatureSplashWrapper>
      <div className='mb-6'>
        <p className='mb-4 fs-4 fw-bold'>✨ Time to get your Super Powers!</p>
        <p className='mb-6 fs-5'>
          Turn every customer interaction into a win. AI B-Card is your digital sales companion,
          capturing leads instantly, remembering every detail, and sending timely follow-ups — so
          you close more deals faster with less effort.
        </p>

        {/* Features List */}
        <div className='mb-8'>
          <div className='d-flex align-items-start mb-3'>
            <div className='timeline-icon symbol symbol-circle symbol-40px mt-1'>
              <i className='bi bi-check-circle-fill check-icon-1'></i>
            </div>
            <span className='text-gray-800 fw-semibold fs-6'>
              <strong>Instant lead capture</strong> – Scan, tap, or share - every contact is saved automatically in seconds.
            </span>
          </div>

          <div className='d-flex align-items-start mb-3'>
            <div className='timeline-icon symbol symbol-circle symbol-40px mt-1'>
              <i className='bi bi-check-circle-fill check-icon-1'></i>
            </div>
            <span className='text-gray-800 fw-semibold fs-6'>
              <strong>AI-Powered follow-ups</strong> – Guided prompts and reminders keep prospects engaged without the manual work.
            </span>
          </div>

          <div className='d-flex align-items-start mb-3'>
            <div className='timeline-icon symbol symbol-circle symbol-40px mt-1'>
              <i className='bi bi-check-circle-fill check-icon-1'></i>
            </div>
            <span className='text-gray-800 fw-semibold fs-6'>
              <strong>Save hours daily</strong> – Cut 15-30 minutes of admin per lead with automated notes and tracking.
            </span>
          </div>

          <div className='d-flex align-items-start mb-3'>
            <div className='timeline-icon symbol symbol-circle symbol-40px mt-1'>
              <i className='bi bi-check-circle-fill check-icon-1'></i>
            </div>
            <span className='text-gray-800 fw-semibold fs-6'>
              <strong>Never miss a detail</strong> – Every interaction is logged with names, preferences, and AI-generated next steps.
            </span>
          </div>

          <div className='d-flex align-items-start mb-3'>
            <div className='timeline-icon symbol symbol-circle symbol-40px mt-1'>
              <i className='bi bi-check-circle-fill check-icon-1'></i>
            </div>
            <span className='text-gray-800 fw-semibold fs-6'>
              <strong>Stop lead leakage</strong> – Close gaps in notes and follow-ups. Clean data, zero busywork.
            </span>
          </div>
        </div>
      </div>
    </FeatureSplashWrapper>
  )
}

export default BcardSplashScreen
